<template>
  <div class="qrcode" id="qrcode" ref="qrcode" title="">
  </div>
</template>

<script>
import QRCode from 'qrcodejs2';

export default {
  name: 'qrcode',
  props: ['w', 'h', 'link'],
  methods: {
    qrcode() {
      document.getElementById('qrcode').innerHTML = '';
      let qrcode = '';
      if (qrcode) {
        qrcode = null;
        qrcode.clear();
        qrcode.makeCode('http://www.m.pingan.com/c3/huodong/2020pacelebration.html');
      } else {
        qrcode = new QRCode('qrcode', {
          width: this.w,
          height: this.h,
          text: this.link,
          background: '#f0f',
          foreground: '#ff0'
        });
      }
    },
    closeEwm(id) {
      // this.$emit('close', id);
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.qrcode();
    });
  },
  destroyed() {
    this.qrcode = null;
  }
};
</script>
<style lang="less">

</style>
